<template>
  <div class="container">
    <!-- 顶部导航 -->
    <headerWX class="headerWX" />

    <div class="top-placeholder"></div>

    <div class="Content">
      <!-- ==================== 标题区域 ==================== -->
      <div class="C-Header">
        <div class="Header-tit">
          <img src="@/assets/imgs/FormATeam/tit1.png" alt="活动标题" />
          <img src="@/assets/imgs/FormATeam/tit2.png" alt="活动副标题" />
        </div>

        <div class="ExplanationBtn">
          <img src="@/assets/imgs/FormATeam/rule.png" alt="规则说明" @click="openDialog(DIALOG_TYPE.RULE)" />
        </div>
      </div>

      <!-- ==================== 未入队 ==================== -->
      <div v-if="!isInTeam" class="Choice">
        <img src="@/assets/imgs/FormATeam/FormTeam.png" alt="创建队伍" @click="openDialog(DIALOG_TYPE.CREATE)" />

        <img src="@/assets/imgs/FormATeam/JoinTeam.png" alt="加入队伍" @click="openDialog(DIALOG_TYPE.JOIN)" />
      </div>

      <!-- ==================== 已入队 ==================== -->
      <div v-else class="ConsumptionBody">
        <!-- 队伍信息 -->
        <div class="textTit">
          <p>
            入队码：
            <span>{{ teamInfo.joinCode || "-" }}</span>
          </p>

          <p>
            队伍名称：
            <span>{{ teamInfo.teamName || "-" }}</span>
          </p>

          <div class="goConsumption" @click="goRecharge">
            <img src="@/assets/imgs/FormATeam/goConsumption.png" alt="去充值" />
          </div>
        </div>

        <!-- 队伍成员 -->
        <div class="items">
          <div v-for="(member, index) in teamMembers" :key="index" class="items_Content">
            <img :src="getMemberAvatar(index)" :alt="`队员${index + 1}`" />

            <div class="item">
              <div v-if="member" class="i">
                <p :title="member.username">
                  玩家名称：{{ member.username || "-" }}
                </p>

                <p>
                  贡献积分：{{ member.personalPoints || 0 }}
                </p>
              </div>

              <div v-else class="i">
                <p>玩家名称：暂无</p>
                <p>贡献积分：暂无</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ==================== 组队消费奖励（优化美化后） ==================== -->
      <div class="ConsumptionRewards">
        <div class="CR-Header">
          <img src="@/assets/imgs/FormATeam/tit3.png" alt="组队消费奖励" />
        </div>

        <div class="RewardBody">
          <div v-for="(tier, index) in tiers" :key="tier.tierPoints || index" class="items">
            <!-- 顶部积分挂坠标签 -->
            <div class="points-tag">
              需贡献积分 <span>{{ tier.tierPoints || 0 }}</span>
            </div>

            <!-- 奖励图片与名称展示区（兼容 1 个或 2 个奖励） -->
            <div class="rewards-wrapper" :class="{ 'multi-rewards': (tier.rewards || []).length > 1 }">
              <div v-for="(item, rIdx) in (tier.rewards || [])" :key="item.itemId || rIdx" class="reward-single-item">
                <!-- 图片展示框 -->
                <div class="RewardImgBox">
                  <el-tooltip effect="dark" :content="item.itemDesc || item.itemName || '奖励'" placement="top">
                    <img :src="item.itemImg" :alt="item.itemName || '奖励'" />
                  </el-tooltip>
                </div>

                <!-- 道具名称 -->
                <p class="reward-name" :title="item.itemName">
                  {{ item.itemName || "-" }}
                </p>
              </div>
            </div>

            <!-- 奖励领取状态按钮 -->
            <div class="RewardBodyBtn">
              <img v-if="!tier.reached" src="@/assets/imgs/FormATeam/component/RewardBodyBtn0.png" alt="未完成" />

              <img v-else-if="!tier.claimed" src="@/assets/imgs/FormATeam/component/RewardBodyBtn1.png" alt="领取"
                @click="claimReward(tier)" />

              <img v-else src="@/assets/imgs/FormATeam/component/RewardBodyBtn2.png" alt="已领取" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-placeholder"></div>

    <!-- ==================== 弹窗 ==================== -->
    <div v-if="istoolTipBox" class="dialog" @click="cancel">
      <popUp :close="cancel" :Confirm="Confirm" :type="type" />
    </div>
  </div>
</template>

<script>
import headerWX from "./component/header.vue";
import popUp from "./component/index.vue";
import Cookies from "js-cookie";

import {
  getInfoApi,
  createTeamApi,
  joinTeamApi,
  claimRewardApi,
} from "@/api/FormATeam";

import { getMemberInfoApi } from "@/api/public.js";

export default {
  name: "FormATeam",

  components: {
    headerWX,
    popUp,
  },

  data() {
    return {
      // 常量
      DIALOG_TYPE: {
        CREATE: 1,
        JOIN: 2,
        RULE: 3,
      },

      // 弹窗状态
      istoolTipBox: false,
      type: 1,

      // 用户信息与活动数据
      userInfo: {},
      totalData: {
        inTeam: false,
        teamInfo: {
          joinCode: "",
          teamName: "",
          members: [],
        },
        tiers: [],
      },
    };
  },

  computed: {
    userId() {
      return Cookies.get("cwsl_userId") || "";
    },

    isInTeam() {
      return this.totalData?.inTeam === true;
    },

    teamInfo() {
      return this.totalData?.teamInfo || {};
    },

    teamMembers() {
      const members = this.teamInfo?.members || [];
      return [members[0] || null, members[1] || null];
    },

    tiers() {
      return Array.isArray(this.totalData?.tiers)
        ? this.totalData.tiers
        : [];
    },
  },

  mounted() {
    this.initUserInfo();
    this.init();
    this.getMemberInfo();
  },

  methods: {
    initUserInfo() {
      try {
        const userInfo = localStorage.getItem("userInfo");
        this.userInfo = userInfo ? JSON.parse(userInfo) : {};
      } catch (error) {
        console.error("读取 userInfo 失败：", error);
        this.userInfo = {};
      }
    },

    async getMemberInfo() {
      try {
        const { data } = await getMemberInfoApi({
          userId: this.userId,
          platForm: "web",
        });

        if (data.state !== 200) {
          this.$message.error(data.message);
          return;
        }

        this.userInfo = data.data;
        localStorage.setItem("userInfo", JSON.stringify(data.data));
      } catch (error) {
        console.error("获取用户信息失败：", error);
        this.$message.error(error.message || "获取用户信息失败");
      }
    },

    async init() {
      try {
        const { data } = await getInfoApi({
          activityName: "202608teamup_activity",
          userId: this.userId,
          platForm: "web",
        });

        if (data.state !== 200) {
          this.$message.error(data.message || "获取活动信息失败");
          return;
        }

        this.totalData = {
          ...this.totalData,
          ...(data.data || {}),
        };
      } catch (error) {
        console.error("获取活动信息失败：", error);
        this.$message.error(error.message || "获取活动信息失败");
      }
    },

    openDialog(type) {
      this.type = type;
      this.istoolTipBox = true;
    },

    cancel() {
      this.istoolTipBox = false;
    },

    Confirm(data) {
      this.cancel();
      if (!data) return;

      switch (data.type) {
        case "Create":
          this.createTeam(data.TeamName);
          break;
        case "Join":
          this.joinTeam(data.TeamName);
          break;
        default:
          break;
      }
    },

    async createTeam(teamName) {
      if (!teamName) {
        this.$message.warning("请输入队伍名称");
        return;
      }

      try {
        const { data } = await createTeamApi({
          activityName: "202608teamup_activity",
          userId: this.userId,
          platForm: "web",
          teamName,
        });

        if (data.state !== 200) {
          this.$message.error(data.message || "创建队伍失败");
          return;
        }

        this.$message.success(data.message || "创建队伍成功");
        await this.init();
      } catch (error) {
        console.error("创建队伍失败：", error);
        this.$message.error(error.message || "创建队伍失败");
      }
    },

    async joinTeam(joinCode) {
      if (!joinCode) {
        this.$message.warning("请输入入队码");
        return;
      }

      try {
        const { data } = await joinTeamApi({
          activityName: "202608teamup_activity",
          userId: this.userId,
          platForm: "web",
          joinCode,
        });

        if (data.state !== 200) {
          this.$message.error(data.message || "加入队伍失败");
          return;
        }

        this.$message.success(data.message || "加入队伍成功");
        await this.init();
      } catch (error) {
        console.error("加入队伍失败：", error);
        this.$message.error(error.message || "加入队伍失败");
      }
    },

    async claimReward(tier) {
      if (!tier || tier.claimed || !tier.reached) return;

      try {
        const { data } = await claimRewardApi({
          activityName: "202608teamup_activity",
          userId: this.userId,
          platForm: "web",
          tierPoints: tier.tierPoints,
        });

        if (data.state !== 200) {
          this.$message.error(data.message || "领取奖励失败");
          return;
        }

        this.$message.success(data?.data?.message || data.message || "领取成功");
        await this.init();
      } catch (error) {
        console.error("领取奖励失败：", error);
        this.$message.error(error.message || "领取奖励失败");
      }
    },

    goRecharge() {
      // window.open("http://shop.818long.com/#/shop");
      this.$router.push({ path: "/recharge" });

    },

    getMemberAvatar(index) {
      return index === 0
        ? require("@/assets/imgs/FormATeam/headPortrait1.png")
        : require("@/assets/imgs/FormATeam/headPortrait2.png");
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  position: relative;
  width: 100%;
  min-width: 1200px;
  max-width: 2000px;
  min-height: 100vh;
  margin: 0 auto;

  background-image: url("../../assets/imgs/FormATeam/bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center top;
  box-sizing: border-box;

  .top-placeholder {
    width: 1px;
    height: 50px;
  }

  .bottom-placeholder {
    width: 1px;
    height: 80px;
  }

  .Content {
    width: 70%;
    margin: 0 auto;
    padding: 20px 0 50px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.45);
    backdrop-filter: blur(5px) saturate(150%);
    -webkit-backdrop-filter: blur(5px) saturate(150%);
    border-radius: 20px;
  }

  .C-Header {
    position: relative;
    width: 100%;

    .Header-tit {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        display: block;
        max-width: 100%;
      }
    }

    .ExplanationBtn {
      position: absolute;
      top: 0;
      right: 30px;
      width: 100px;
      cursor: pointer;

      img {
        display: block;
        width: 100%;
      }
    }
  }

  .Choice {
    display: flex;
    width: 50%;
    margin: 20px auto;
    justify-content: space-around;
    align-items: center;

    img {
      display: block;
      cursor: pointer;
      transform: translateY(0);
      transition: transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);

      &:hover {
        transform: translateY(-5px);
      }
    }
  }

  .ConsumptionBody {
    width: 70%;
    margin: 30px auto;

    .textTit {
      position: relative;
      display: flex;
      gap: 20px;
      justify-content: center;

      p {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        color: #fff;
        text-shadow:
          -1px -1px 0 #f05c7d,
          1px -1px 0 #f05c7d,
          -1px 1px 0 #f05c7d,
          1px 1px 0 #f05c7d,
          0 2px 0 #e95778,
          0 3px 5px rgba(226, 77, 112, 0.55);

        span {
          display: inline-block;
          width: 180px;
          padding: 0 10px;
          border-bottom: 2px solid #fff;
          box-sizing: border-box;
          font-size: 20px;
          text-align: center;
        }
      }

      .goConsumption {
        position: absolute;
        right: -50px;
        bottom: 0;
        cursor: pointer;

        img {
          display: block;
        }
      }
    }

    .items {
      display: grid;
      width: 75%;
      margin: 50px auto 0;
      gap: 60px;
      grid-template-columns: repeat(2, 1fr);

      .items_Content {
        text-align: center;

        >img {
          display: block;
          max-width: 90%;
          margin: 0 auto 20px;
        }
      }

      .item {
        width: 100%;
        max-width: 260px;
        height: 80px;
        margin: 0 auto;
        background-image: url("../../assets/imgs/FormATeam/ConsumptionBody_bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;

        .i {
          display: flex;
          width: 85%;
          height: 100%;
          margin: 0 auto;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 10px;
        }

        p {
          width: 95%;
          margin: 0;
          overflow: hidden;
          font-weight: 700;
          color: #a2763a;
          text-align: center;
          white-space: nowrap;
          text-overflow: ellipsis;
          user-select: none;
        }
      }
    }
  }

  // =========================================================
  // 奖励 (全量优化后的毛玻璃 + 悬浮勋章样式)
  // =========================================================

  .ConsumptionRewards {
    margin-top: 15px;

    .CR-Header {
      margin: 0 auto 20px;
      text-align: center;

      img {
        display: inline-block;
      }
    }

    .RewardBody {
      display: flex;
      width: 85%;
      margin: 0 auto;
      justify-content: center;
      align-items: center;
      gap: 35px;

      .items {
        position: relative;
        width: 240px;
        /* 适当增加宽度，保证 2 个图标能并排放下 */
        min-height: 310px;
        flex-shrink: 0;
        box-sizing: border-box;
        padding: 35px 12px 20px;

        /* 毛玻璃 + 渐变底座 */
        background: linear-gradient(165deg, rgba(255, 255, 255, 0.85) 0%, rgba(255, 235, 242, 0.65) 100%);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        border: 2px solid rgba(255, 255, 255, 0.95);
        border-radius: 20px;
        box-shadow:
          0 10px 25px rgba(226, 77, 112, 0.18),
          inset 0 0 15px rgba(255, 255, 255, 0.8);

        display: flex;
        flex-direction: column;
        align-items: center;
        transition: transform 0.3s ease, box-shadow 0.3s ease;

        &:hover {
          transform: translateY(-8px);
          box-shadow: 0 16px 30px rgba(226, 77, 112, 0.3);
        }

        /* 顶部悬浮积分标签 */
        .points-tag {
          position: absolute;
          top: -14px;
          left: 50%;
          transform: translateX(-50%);
          white-space: nowrap;
          background: linear-gradient(90deg, #ff7597, #f05c7d);
          color: #ffffff;
          font-size: 13px;
          font-weight: 700;
          padding: 4px 16px;
          border-radius: 12px;
          border: 2px solid #ffffff;
          box-shadow: 0 3px 8px rgba(240, 92, 125, 0.4);

          span {
            font-size: 15px;
            color: #ffeb3b;
          }
        }

        /* 奖励展示包裹层 */
        .rewards-wrapper {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          gap: 10px;
          width: 100%;
          margin-bottom: 10px;

          /* 单个奖励 */
          .reward-single-item {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            max-width: 100px;
          }

          /* 只有 1 个奖励时居中显示大图 */
          &:not(.multi-rewards) {
            .reward-single-item {
              max-width: 120px;

              .RewardImgBox {
                width: 90px;
                height: 90px;
              }
            }
          }

          /* 当有 2 个奖励时，自动缩小尺寸并排 */
          &.multi-rewards {
            .reward-single-item {
              .RewardImgBox {
                width: 72px;
                height: 72px;
              }

              .reward-name {
                font-size: 12px;
              }
            }
          }
        }

        /* 图片框 */
        .RewardImgBox {
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(255, 255, 255, 0.8);
          border-radius: 14px;
          border: 1px solid rgba(240, 92, 125, 0.15);
          box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.03);
          margin-bottom: 8px;

          img {
            max-width: 85%;
            max-height: 85%;
            object-fit: contain;
            cursor: pointer;
            transition: transform 0.2s;

            &:hover {
              transform: scale(1.1);
            }
          }
        }

        /* 道具名称 */
        .reward-name {
          width: 100%;
          font-size: 13px;
          font-weight: 700;
          color: #7a4352;
          text-align: center;
          line-height: 1.25;
          height: 32px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          margin: 0;
        }

        /* 底部按钮 */
        .RewardBodyBtn {
          width: 100%;
          text-align: center;
          margin-top: auto;

          img {
            display: inline-block;
            max-width: 85%;
            height: auto;
            cursor: pointer;
            transition: transform 0.2s ease, filter 0.2s ease;

            &:hover {
              transform: scale(1.05);
            }

            &:active {
              transform: scale(0.96);
            }
          }
        }
      }
    }
  }

  /* 弹窗遮罩 */
  .dialog {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    display: flex;
    width: 100vw;
    height: 100vh;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.8);
  }

  .headerWX {
    width: 100%;
  }
}
</style>